module.exports = __webpack_public_path__ + "img/airpay_img.6031741e.png";